import React, { useState } from "react";
import { useTurnstile, AVISO_TURNSTILE } from "@/components/Turnstile";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const robo = useTurnstile("senha");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (robo.falta) { setError(AVISO_TURNSTILE); return; }
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, turnstile: robo.usar() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#F8FAFC]">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl p-8 animate-fade-up">
        <Brand size="md" className="mb-6" />
        {sent ? (
          <div data-testid="forgot-sent">
            <MailCheck className="h-10 w-10 text-[#1E9E2A]" />
            <h2 className="font-display text-2xl font-bold text-slate-900 mt-4">Verifique seu e-mail</h2>
            <p className="text-slate-500 text-sm mt-2 leading-relaxed">
              Se <strong>{email}</strong> estiver cadastrado, você vai receber um link para criar uma nova senha.
              O link vale por 1 hora. Confira também a caixa de spam.
            </p>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold text-slate-900">Esqueci minha senha</h2>
            <p className="text-slate-500 text-sm mt-2 mb-4">Informe o e-mail da sua conta e enviaremos um link para redefinir a senha.</p>
            <p className="text-xs text-slate-500 bg-green-50 border border-green-100 rounded-lg px-3 py-2 mb-6 leading-relaxed">
              <strong>Primeiro acesso?</strong> Se você já era aluno(a) do IEP, use o mesmo e-mail da plataforma antiga para criar sua senha.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="fp-email">E-mail</Label>
                <Input id="fp-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@email.com" required className="h-11" data-testid="forgot-email-input" />
              </div>
              {error && <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</div>}
              {robo.caixa}
              <Button type="submit" disabled={loading} className="w-full h-11 text-white font-semibold" style={{ background: "#232D4F" }} data-testid="forgot-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enviar link"}
              </Button>
            </form>
          </>
        )}
        <Link to="/login" className="inline-flex items-center gap-1 text-sm font-semibold text-[#1E9E2A] mt-6 hover:underline">
          <ArrowLeft className="h-4 w-4" /> Voltar para o login
        </Link>
      </div>
    </div>
  );
}
